import { Input, Modal } from "components";
import React, { useEffect } from "react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { useDebounce } from "utilities/usehooks";
import { containsAnyMergefields, getFilteredMergetopics } from "../../../exceltemplate/ColumnsPanel/utils";
import MergeTopicColumn from "./MergeTopic";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { nounToLower } from "utilities/translationUtils";

interface Props {
  sectionName: string
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
  isOpen: boolean
  onClose: () => void
  onSelect: (mergeField: string) => void
}

const SelectMergeFieldModal = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();
  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery);

  const filteredMergeTopics = getFilteredMergetopics(props.availableMergeFieldTopics, debouncedSearchQuery)
    .filter(topic => containsAnyMergefields(topic));
  const hasResults = filteredMergeTopics.length > 0;

  useEffect(() => {
    if (props.isOpen) {
      semanticRef.ref.current.focus();
    }
  }, [props.isOpen]);

  return <Modal
    isOpen={props.isOpen}
    title={RESX.Template.MergeFieldsForSection.replace("{0}", nounToLower(props.sectionName))}
    width="large"
    height={1200}
    handleClose={() => props.onClose()}
  >
    <Input
      ref={semanticRef.refSetter}
      onChange={(_, { value }) => { setSearchQuery(value); }}
      value={searchQuery}
      icon="search"
      placeholder={RESX.GeneralLabels.Search}
      fluid
    />
    {!hasResults && <NoDataAvailableDiv />}
    {hasResults && <div className="grow1 scrollbox-auto margin-bottom">
      <div className="flex-column gap">
        {filteredMergeTopics.map((mergeTopic) => (
          <MergeTopicColumn
            key={mergeTopic.label}
            mergeTopic={mergeTopic}
            onSelect={(mergeField) => {
              props.onSelect(mergeField);
            }}
          />
        ))}
      </div>
    </div>}
  </Modal>;
}

export default SelectMergeFieldModal;